import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class StringToNumberAdapter implements JsonCustomConvert<number | undefined> {
    serialize(value: number): string {
        return value !== null && value !== undefined ? String(value) : undefined;
    }

    deserialize(value: string): number | undefined {
        return value ? Number(value.replace(',', '.')) : 0;
    }
}
